import React, { useState, useEffect } from "react";
import arrowIcon from '../assets/images/icons/arrow-angle-down-icon.svg';

const SelectDropdown = ({ options, onSelect, placeholder, placeholderIcon, className, showSpecificItem, showIcon }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);

    // Set the initial selected value if showSpecificItem is provided
    useEffect(() => {
        if (showSpecificItem !== undefined && options[showSpecificItem]) {
            setSelectedValue(options[showSpecificItem]);
        }
    }, [showSpecificItem, options]);

    const handleSelect = (option) => {
        setSelectedValue(option);
        onSelect(option); // Pass the selected option to the parent
        setIsOpen(false);
    };

    return (
        <div className={`custom-select ${className}`}>
            <div className="select-header" onClick={() => setIsOpen(!isOpen)}>
                <div className="name-wrapper">
                    {(showIcon !== false) &&
                        <div className="icon">
                            <img
                                src={selectedValue ? selectedValue.icon : placeholderIcon}
                                alt="icon"
                                className="select-main-icon"
                            />
                        </div>
                    }
                    <div className="content">
                        <p className="p w-600">{selectedValue ? selectedValue.label : placeholder}</p>
                    </div>
                </div>
                <div className="arrow-wrapper">
                    <a href="#" className={`arrow ${isOpen ? "open" : ""}`}>
                        <img src={arrowIcon} alt="icon" />
                    </a>
                </div>
            </div>
            {isOpen && (
                <ul className="select-options">
                    {options.map((option, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelect(option)}
                            className={`select-option ${selectedValue == option ? "selected" : ""}`}
                        >
                            <a href="#" className={`option-card ${selectedValue == option ? "active" : ""}`}>
                                <div className="option-name">
                                    {(showIcon !== false) &&
                                        <div className="icon-wrapper">
                                            <img src={option.icon} alt={option.label} className="option-icon" />
                                        </div>
                                    }
                                    <p className="p w-600">{option.label}</p>
                                </div>
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SelectDropdown;
